__turbopack_context__.v({
  "fullWidth": "Bfp-module__UIAata__fullWidth",
  "label": "Bfp-module__UIAata__label",
  "negative": "Bfp-module__UIAata__negative",
  "root": "Bfp-module__UIAata__root",
});
